
import { useStates } from "@/hooks/useStates";
import { PersonalInfoFields } from "./PersonalInfoFields";
import { AddressFields } from "./AddressFields";
import { FormActions } from "./components/FormActions";
import { useNewClientForm } from "./hooks/useNewClientForm";

export const NewClientForm = () => {
  const { data: states = [], isLoading: isLoadingStates } = useStates();
  const { formData, handleInputChange, handleStateChange, handleSubmit, isSubmitting } = useNewClientForm();

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-6">
        <PersonalInfoFields
          formData={formData}
          onChange={handleInputChange}
        />
        <AddressFields
          formData={formData}
          onChange={handleInputChange}
          onStateChange={handleStateChange}
          states={states}
          isLoadingStates={isLoadingStates}
        />
      </div>
      <FormActions onSubmit={handleSubmit} isSubmitting={isSubmitting} />
    </form>
  );
};
